module.exports = __webpack_public_path__ + "img/img13.579f8170.png";